module.exports = __webpack_public_path__ + "img/certificate-en-short.ecce90c1.png";